import { render, staticRenderFns } from "./FooterLpTop.vue?vue&type=template&id=ace32176&"
import script from "./FooterLpTop.vue?vue&type=script&lang=js&"
export * from "./FooterLpTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports